import { LoginCallback, LogoutCallback } from '@myosh/myosh-login'
import React from 'react'
import { Route, Routes } from 'react-router'
import TmsApp from './components/training-management'
import LoginPage from './pages/login.page'
import PrivateLayoutRoute from './pages/private-layout-route'

function App() {
  return (
    <Routes>
      <Route path='/auth/cb/logout' element={<LogoutCallback />} />
      <Route path='/auth/cb/silent' element={<div>Silent renewal callback</div>} />
      <Route path='/auth/cb' element={<LoginCallback />} />
      <Route path='/login' element={<LoginPage />} />
      <Route path='/' element={<PrivateLayoutRoute />}>
        <Route index element={<TmsApp />} />
      </Route>
    </Routes>
  )
}

export default React.memo(App)
